import Vue from 'vue';

const en = require("json-loader!yaml-loader!../config/locales/ds.en.yml");
const de = require("json-loader!yaml-loader!../config/locales/ds.de.yml");
const es = require("json-loader!yaml-loader!../config/locales/ds.es.yml");
const fr = require("json-loader!yaml-loader!../config/locales/ds.fr.yml");
const he = require("json-loader!yaml-loader!../config/locales/ds.he.yml");
const it = require("json-loader!yaml-loader!../config/locales/ds.it.yml");
const nl = require("json-loader!yaml-loader!../config/locales/ds.nl.yml");
const pl = require("json-loader!yaml-loader!../config/locales/ds.pl.yml");
const pt = require("json-loader!yaml-loader!../config/locales/ds.pt.yml");
const ru = require("json-loader!yaml-loader!../config/locales/ds.ru.yml");
const keys = require("json-loader!yaml-loader!../config/locales/ds.keys.yml");
const pseudo = require("json-loader!yaml-loader!../config/locales/ds.pseudo.yml");
const tr = require("json-loader!yaml-loader!../config/locales/ds.tr.yml");

const messages = Object.assign(en, es, de, fr, he, it, nl, pl, pt, ru, keys, pseudo, tr);

const initI18n = (locale = 'en') => {
    if (!Vue.prototype.$ds) {
        Vue.prototype.$ds = {};
    }

    Vue.prototype.$ds.setLocale = (locale) => {
        Vue.prototype.$ds.locale = locale;
    }

    Vue.prototype.$ds.setLocale(locale);

    Vue.prototype.$dst = (key, params) => {
        const language = messages[Vue.prototype.$ds.locale] || messages['en'];

        const path = key.split('.');
        let result = language;
        try {
            for (let item of path) {
                result = result[item];
            }
            for (let param in params) {
                let regex = new RegExp(`{${param}}`,'gi')
                result = result.replace(regex, params[param])
            }
        }
        catch {
            result = key;
        }
        
        return result;
    }
}

export default initI18n;